<template>
    <div class="app-container1">
   <div id="base" class="">

     

      <!-- Unnamed (Rectangle) -->
      <div id="u2346" class="ax_default box_1">
        <div id="u2346_div" class=""></div>
        <div id="u2346_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u2347" class="ax_default box_1">
        <div id="u2347_div" class=""></div>
        <div id="u2347_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u2348" class="ax_default box_1">
        <div id="u2348_div" class=""></div>
             <div id="u23481" class="innerbox" >
             <!-- for循环展示区域详情信息 -->
           
<table style="border-collapse:collapse;border-spacing: 0;" cellspacing="0" cellpadding="0">

<template v-for="item in quotaLevel2VO.arealist">

  <tr style="height:18px"> 
      <td align="left" width="170"><span style="font-size:14px;">&nbsp;&nbsp;&nbsp;&nbsp;{{item.area}}</span></td>   
      <td align="left" width="50"><span style="font-size:14px;">总定额</span></td>     
      <td align="left" width="70"><span style="font-size:14px;">{{item.actural}}元</span></td>  
       <td align="left" width="70"><span style="font-size:14px;">消费定额</span></td>     
      <td align="left" width="70"><span style="font-size:14px;">{{item.consumequota}}元</span></td> 
       <td align="left" width="70"><span style="font-size:14px;">剩余定额</span></td>     
      <td align="left" width="70"><span style="font-size:14px;">{{item.remainquota}}元</span></td>    
  </tr>
 
  <tr style="height:18px">  
    <td colspan="3"></td>
  </tr>
</template>

 </table>


           </div>
      </div>

  

      <!-- Unnamed (Line) -->
      <div id="u2350" class="ax_default line">
        <img id="u2350_img" class="img " src="../../../../../../assets/common/consumption/icon/month/u354.svg"/>
        <div id="u2350_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u2351" class="ax_default label">
        <div id="u2351_div" class=""></div>
        <div id="u2351_text" class="text ">
          <p><span>区域年度定额</span></p>
        </div>
      </div>

    

 

      <!-- Unnamed (Group) -->
      <div id="u2361" class="ax_default" data-left="845" data-top="219" data-width="532" data-height="134">

        <!-- Unnamed (Rectangle) -->
        <div id="u2362" class="ax_default box_1">
          <div id="u2362_div" class=""></div>
           <div id="u23481" class="innerbox" >
             <!-- for循环展示区域详情信息 -->
           
<table style="border-collapse:collapse;border-spacing: 0;" cellspacing="0" cellpadding="0">

<template v-for="item in quotaLevel2VO.arealist">

  <tr style="height:18px"> 
      <td align="left" width="180"><span style="font-size:14px;">&nbsp;&nbsp;&nbsp;&nbsp;{{item.area}}</span></td>   
      <td align="left" width="80"><span style="font-size:14px;">总定额</span></td>     
      <td align="left" width="80"><span style="font-size:14px;">{{item.forecast}}元</span></td>  
 
  </tr>
 
  <tr style="height:18px">  
    <td colspan="3"></td>
  </tr>
</template>

 </table>


           </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u2363" class="ax_default label">
          <div id="u2363_div" class=""></div>
          <div id="u2363_text" class="text ">
            <p><span>区域下一年度定额预测</span></p>
          </div>
        </div>

        <!-- Unnamed (Line) -->
        <div id="u2364" class="ax_default line">
          <img id="u2364_img" class="img " src="../../../../../../assets/common/consumption/icon/month/u354.svg"/>
          <div id="u2364_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

        <!-- Unnamed (Group) -->
     
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u2373" class="ax_default button" @click="routerurl(1)">
        <div id="u2373_div" class=""></div>
        <div id="u2373_text" class="text ">
          <p><span>用电</span></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u2374" class="ax_default button" @click="routerurl(2)">
        <div id="u2374_div" class=""></div>
        <div id="u2374_text" class="text ">
          <p><span>用水</span></p>
        </div>
      </div>

      <!-- Unnamed (Line) -->
      <div id="u2375" class="ax_default line">
        <img id="u2375_img" class="img " src="../../../../../../assets/common/consumption/icon/month/u336.svg"/>
        <div id="u2375_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u2376" class="ax_default button" @click="routerurl(3)">
        <div id="u2376_div" class=""></div>
        <div id="u2376_text" class="text ">
          <p><span>用气</span></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u2377" class="ax_default button" @click="routerurl(4)">
        <div id="u2377_div" class=""></div>
        <div id="u2377_text" class="text ">
          <p><span>用热</span></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u2378" class="ax_default button" @click="routerurl(5)">
        <div id="u2378_div" class=""></div>
        <div id="u2378_text" class="text ">
          <p><span>其他能源</span></p>
        </div>
      </div>

      <!-- Unnamed (Group) -->
      <div id="u2379" class="ax_default" data-left="258" data-top="399" data-width="1152" data-height="285">

        <!-- Unnamed (Rectangle) -->
        <div id="u2380" class="ax_default label">
          <div id="u2380_div" class=""></div>
          <div id="u2380_text" class="text ">
            <p><span>定额详情</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u2381" class="ax_default box_1">
          <div id="u2381_div" class=""></div>
          <div id="u2381_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

     <div id="u7745" class="ax_default label">
        <div id="u7745_div" class=""></div>
        <div id="u7745_text" class="text ">
          <p><span>项目</span></p>
        </div>
      </div>
 <!-- Unnamed (Droplist) -->
      <div id="u7752" class="ax_default droplist">
        <div id="u7752_div" class=""></div>
        <!--
        <select id="u774_input" class="u774_input" v-model="queryParams.area">
          <option class="u774_input_option" selected value="">全部</option>
          <option class="u774_input_option" value="一期">一期</option>
          <option class="u774_input_option" value="二期">二期</option>
        </select>
        -->
          <el-select  @change="changeProject" clearable v-model="queryParams.projectId"  placeholder="选择项目">
                                            <el-option
                                                    v-for="item in projectList"
                                                    :label="item.projectName"
                                                    :value="item.projectId"
                                                    :key="item.projectId">
                                            </el-option>
                    </el-select>
      </div>
        <!-- Unnamed (Rectangle) -->
        <div id="u2382" class="ax_default label">
          <div id="u2382_div" class=""></div>
          <div id="u2382_text" class="text ">
            <p><span>区域</span></p>
          </div>
        </div>

        <!-- Unnamed (Droplist) -->
        <div id="u2383" class="ax_default droplist">
          <tree-select
                                    v-model="queryParams.positionId"
                                    @select="selectPosition"
                                    :disable-branch-nodes="false"
                                    :multiple="false"
                                    :show-count="true"
                                    :flat="true"
                               
                                    :autoFocus="true"
                                    :placeholder="$t('commons.selectPlease')"
                                    :options="positionList" />
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u2384" class="ax_default label">
          <div id="u2384_div" class=""></div>
          <div id="u2384_text" class="text ">
            <p><span>周期</span></p>
          </div>
        </div>

        <!-- Unnamed (Image) -->
        <div id="u2385" class="ax_default image">
         <el-date-picker
              :default-time="['00:00:00','23:59:59']"
              type="monthrange"
              range-separator=":"
              size="small"
              class="date-item"
              format="yyyy-MM"
              value-format="yyyy-MM-dd HH:mm:ss"
               v-model="pickerOpts.pickerData"
                  :picker-options="pickerOpts"
                   @change="setDateRange"
              start-placeholder="起始时间"
              end-placeholder="截止时间"
            />
         <div id="u2385_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u2386" class="ax_default primary_button"  @click="handleQuery">
          <div id="u2386_div" class=""></div>
          <div id="u2386_text" class="text ">
            <p><span>查询</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u2387" class="ax_default box_1">
          <div id="u2387_div" class=""></div>
          <div id="u2387_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u2388" class="ax_default heading_1">
          <div id="u2388_div" class=""></div>
          <div id="u2388_text" class="text ">
            <p><span>时间</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u2389" class="ax_default heading_1">
          <div id="u2389_div" class=""></div>
          <div id="u2389_text" class="text ">
            <p><span>能耗类型</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
     

        <!-- Unnamed (Rectangle) -->
        <div id="u2391" class="ax_default primary_button">
          <div id="u2391_div" class=""></div>
          <div id="u2391_text" class="text ">
            <p><span>导出</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u2392" class="ax_default label">
        <div class="innerbox"  style="width: 100%; height:350px;position: absolute;z-index: 99;">
        <el-table  :data="consumptionList"  v-loading="loading"
                style="width: 100%;"
         
                >
              
                <el-table-column label="时间" align="center" prop="energyMonth" />
              <el-table-column label="区域" align="center" prop="area" />
       
                 <el-table-column label="定额" align="center" prop="quota" />
                <el-table-column label="消耗定额" align="center" prop="consumequota" />
                <el-table-column label="剩余定额" align="center" prop="remainquota" />
             </el-table>
               <pagination v-show="total>0" 
                  :total="total" 
                  :page.sync="queryParams.pageNum"
                  :limit.sync="queryParams.pageSize"
                  @pagination="getList"/>
             </div>
        </div>

        <!-- Unnamed (Rectangle) 
        <div id="u2393" class="ax_default label">
          <div id="u2393_div" class=""></div>
          <div id="u2393_text" class="text ">
            <p><span>分项</span></p>
          </div>
        </div>

        
        <div id="u2394" class="ax_default droplist">
          <div id="u2394_div" class=""></div>
          <select id="u2394_input" class="u2394_input">
            <option class="u2394_input_option" selected value="全部">全部</option>
            <option class="u2394_input_option" value="冷暖空调">冷暖空调</option>
            <option class="u2394_input_option" value="照明插座">照明插座</option>
            <option class="u2394_input_option" value="动力设备">动力设备</option>
            <option class="u2394_input_option" value="特殊用电">特殊用电</option>
          </select>
        </div>

       
        <div id="u2395" class="ax_default label">
          <div id="u2395_div" class=""></div>
          <div id="u2395_text" class="text ">
            <p><span>能耗类型</span></p>
          </div>
        </div>

       
        <div id="u2396" class="ax_default droplist">
          <div id="u2396_div" class=""></div>
          <select id="u2396_input" class="u2396_input">
            <option class="u2396_input_option" selected value="请选择">请选择</option>
            <option class="u2396_input_option" value="电费">电费</option>
            <option class="u2396_input_option" value="水费">水费</option>
            <option class="u2396_input_option" value="燃气费">燃气费</option>
            <option class="u2396_input_option" value="热力费">热力费</option>
            <option class="u2396_input_option" value="其他能源费用">其他能源费用</option>
          </select>
        </div>
-->
        <!-- Unnamed (Rectangle) 
        <div id="u2397" class="ax_default heading_1">
          <div id="u2397_div" class=""></div>
          <div id="u2397_text" class="text ">
            <p><span>区域</span></p>
          </div>
        </div>

       
        <div id="u2398" class="ax_default heading_1">
          <div id="u2398_div" class=""></div>
          <div id="u2398_text" class="text ">
            <p><span>分项</span></p>
          </div>
        </div>

       
        <div id="u2399" class="ax_default heading_1">
          <div id="u2399_div" class=""></div>
          <div id="u2399_text" class="text ">
            <p><span>定额</span></p>
          </div>
        </div>

      
        <div id="u2400" class="ax_default heading_1">
          <div id="u2400_div" class=""></div>
          <div id="u2400_text" class="text ">
            <p><span>消耗定额</span></p>
          </div>
        </div>

        <div id="u2401" class="ax_default heading_1">
          <div id="u2401_div" class=""></div>
          <div id="u2401_text" class="text ">
            <p><span>剩余定额</span></p>
          </div>
        </div>
        -->
      </div>

  
    </div>
    </div>
</template>
<script>
import "echarts/theme/macarons";
import {
 getGasLevel2,
  getPowerLevel2,//电
   getQuotaLevel1,//总汇总
   listGas,
} from "@/api/business/energy/quota";
import{
        getProjectList
    }from '@/api/business/base/tenant/project';
    import {      
        getPositionTree
    } from '@/api/business/base/tenant/device';
     import {listToTree} from '@/utils/tree';
    import TreeSelect from '@riophae/vue-treeselect';   
        import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import Pagination from '@/components/Pagination';
export default {
  name: "energyOverview",
     components: {Pagination,TreeSelect},
  data() {
    
    return {
        flag:1,
        radio: 0,
        // 遮罩层
      loading: false,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 岗位表格数据
      quotaList: [],
      consumptionList: [],
        projectList:[],
           positionList:[],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 状态数据字典
      statusOptions: [],
      queryParams: {
                   pageNum: 1,
                   pageSize: 10,
                   energyType: '',
                   area: '',
                      areaid: null,
                 positionId : null,
                   projectId: null,
                   startTime: null,
                   endTime: null
               },
               // 日期范围查询组件
               pickerOpts: {
                   // 默认日期
                   pickerData: null,
                   // 快捷选项
                   shortcuts: null,
               },

      yearAnalysis: [],
      seasonAnalysis: [],
      monthAnalysis: [],
      //---电
      poweryearAnalysis: [],
      powerseasonAnalysis: [],
      powermonthAnalysis: [],
      //---水
      wateryearAnalysis: [],
      waterseasonAnalysis: [],
      watermonthAnalysis: [],

      //---气

     gasyearAnalysis: [],
     gasseasonAnalysis: [],
     gasmonthAnalysis: [],
      //--热
     hotyearAnalysis: [],
     hotseasonAnalysis: [],
     hotmonthAnalysis: [],

      //--其他
     othersyearAnalysis: [],
     othersseasonAnalysis: [],
     othersmonthAnalysis: [],

      feeTypeList: [
        { itemCode: 2, itemName: "电" },
        { itemCode: 3, itemName: "水" },
        { itemCode: 4, itemName: "天然气" },
        { itemCode: 5, itemName: "热力" },
        { itemCode: 5, itemName: "其他" },
      ],

   
    
      monthlyProportionOptions: null,
      seasonProportionOptions: null,
      yearlyProportionOptions: null,
      monthlyProportionOptionsRate: null,
      seasonProportionOptionsRate: null,
      gasmonthlyProportionOptions: null,
      gasseasonProportionOptions: null,
      gasyearlyProportionOptions: null,

      watermonthlyProportionOptions: null,
      waterseasonProportionOptions: null,
      wateryearlyProportionOptions: null,

      powermonthlyProportionOptions: null,
      powerseasonProportionOptions: null,
      poweryearlyProportionOptions: null,

      hotmonthlyProportionOptions: null,
      hotseasonProportionOptions: null,
      hotyearlyProportionOptions: null,

      othersmonthlyProportionOptions: null,
      othersseasonProportionOptions: null,
      othersyearlyProportionOptions: null,
       montharr: [],//月份
      montharr2: [],//月份
      dataarr: [],//目标值
      dataarr2: [],//实际值
      dataarr3: [],//预测值
      dataarr4: [],//评价
      forcastdata:null,
      rightHeader: [],
      rightsDate: [],
       tableData: [],
       totalquota: '',
       consumequota: '',
       remainquota: '',
       curmonthshow: '',
       quotawarn: '',
       quotaForecast: '',
            //-
                quotaLevel2VO: {
          arealist: [],
          airconditionactural: "",
          airconditionforeast: "",
          lightactural: "",
          lightforeast: "",
          poweractural: "",
          powerforeast: "",
          specialractural: "",
          specialforeast: "",

          wateractural: "",
          waterforeast: "",

          gasactural: "",
          gasforeast: "",

          hotactural: "",
          hotforeast: "",

          othersactural: "",
          othersforeast: "",

          tapwateractural: "",
          tapwaterforecast: "",

          reclaimedwateractural: "",
          reclaimedwaterforecast: "",
        },
        //接收总统计数据的对象
        quotaLevel1VO: {
          //----------汇总年数据-------------
    //今年总定额目标
    powerYear: "",//1
    waterYear: "",//2
    gasYear: "",//3
    hotYear: "",//4
    othersYear: "",//5
    totalYear: "",//0
    consumequota: "",
    remainquota: "",

    //---今年总定额消费额度
    powerConsumeYear: "",
    waterConsumeYear: "",
    gasConsumeYear: "",
    hotConsumeYear: "",
    othersConsumeYear: "",
    totalConsumeYear: "",

    //---今年剩余额度
    powerRemainYear: "",
    waterRemainYear: "",
    gasRemainYear: "",
    hotRemainYear: "",
    othersRemainYear: "",
    totalRemainYear: "",

    //---今年警告额度
    powerWarnYear: "",
    waterWarnYear: "",
    gasWarnYear: "",
    hotWarnYear: "",
    othersWarnYear: "",
    totalWarnYear: "",

    //--下一周期预测
    powerForecastYear: "",
    waterForecastYear: "",
    gasForecastYear: "",
    hotForecastYear: "",
    othersForecastYear: "",
    totalForecastYear: "",
    //----------------汇总季-----------------------------
    //
    totalSeason1: "",
    totalSeason2: "",
    totalSeason3: "",
    totalSeason4: "",


    //---季度消费额度
    totalConsumeSeason1: "",
    totalConsumeSeason2: "",
    totalConsumeSeason3: "",
    totalConsumeSeason4: "",

    //---季剩余额度
    totalRemainSeason1: "",
    totalRemainSeason2: "",
    totalRemainSeason3: "",
    totalRemainSeason4: "",

    //---季警告额度
    totalWarnSeason1: "",
    totalWarnSeason2: "",
    totalWarnSeason3: "",
    totalWarnSeason4: "",


    //--季下一周期预测
    totalForecastSeason1: "",
    totalForecastSeason2: "",
    totalForecastSeason3: "",
    totalForecastSeason4: "",

    //----------------电-----------------------------
    //电季
    powerSeason1: "",
    powerSeason2: "",
    powerSeason3: "",
    powerSeason4: "",


    //---季度消费额度
    powerConsumeSeason1: "",
    powerConsumeSeason2: "",
    powerConsumeSeason3: "",
    powerConsumeSeason4: "",

    //---季剩余额度
    powerRemainSeason1: "",
    powerRemainSeason2: "",
    powerRemainSeason3: "",
    powerRemainSeason4: "",
    //---季警告额度
    powerWarnSeason1: "",
    powerWarnSeason2: "",
    powerWarnSeason3: "",
    powerWarnSeason4: "",

    //--季下一周期预测
    powerForecastSeason1: "",
    powerForecastSeason2: "",
    powerForecastSeason3: "",
    powerForecastSeason4: "",


    //---------------水----------------------------------------

    //水季
    waterSeason1: "",
    waterSeason2: "",
    waterSeason3: "",
    waterSeason4: "",
    //---季消费额度
    waterConsumeSeason1: "",
    waterConsumeSeason2: "",
    waterConsumeSeason3: "",
    waterConsumeSeason4: "",

    //---季剩余额度
    waterRemainSeason1: "",
    waterRemainSeason2: "",
    waterRemainSeason3: "",
    waterRemainSeason4: "",
    //---季警告额度
    waterWarnSeason1: "",
    waterWarnSeason2: "",
    waterWarnSeason3: "",
    waterWarnSeason4: "",

    //--水季下一周期预测
    waterForecastSeason1: "",
    waterForecastSeason2: "",
    waterForecastSeason3: "",
    waterForecastSeason4: "",

    //--------------气--------------------------------------
    //气
    gasSeason1: "",
    gasSeason2: "",
    gasSeason3: "",
    gasSeason4: "",
    //---季消费额度
    gasConsumeSeason1: "",
    gasConsumeSeason2: "",
    gasConsumeSeason3: "",
    gasConsumeSeason4: "",
    //---季剩余额度
    gasRemainSeason1: "",
    gasRemainSeason2: "",
    gasRemainSeason3: "",
    gasRemainSeason4: "",
    //---季警告额度
    gasWarnSeason1: "",
    gasWarnSeason2: "",
    gasWarnSeason3: "",
    gasWarnSeason4: "",


    //--气下一周期预测
    gasForecastSeason1: "",
    gasForecastSeason2: "",
    gasForecastSeason3: "",
    gasForecastSeason4: "",

    //--------------热-----------------------------
    //热
    hotSeason1: "",
    hotSeason2: "",
    hotSeason3: "",
    hotSeason4: "",
    //---季消费额度
    hotConsumeSeason1: "",
    hotConsumeSeason2: "",
    hotConsumeSeason3: "",
    hotConsumeSeason4: "",
    //---季剩余额度
    hotRemainSeason1: "",
    hotRemainSeason2: "",
    hotRemainSeason3: "",
    hotRemainSeason4: "",
    //---季警告额度
    hotWarnSeason1: "",
    hotWarnSeason2: "",
    hotWarnSeason3: "",
    hotWarnSeason4: "",

    //--热季下一周期预测
    hotForecastSeason1: "",
    hotForecastSeason2: "",
    hotForecastSeason3: "",
    hotForecastSeason4: "",
    //----------------其他-----------------------------
    //其他
    othersSeason1: "",
    othersSeason2: "",
    othersSeason3: "",
    othersSeason4: "",


    //---季消费额度
    othersConsumeSeason1: "",
    othersConsumeSeason2: "",
    othersConsumeSeason3: "",
    othersConsumeSeason4: "",

    //---季剩余额度
    othersRemainSeason1: "",
    othersRemainSeason2: "",
    othersRemainSeason3: "",
    othersRemainSeason4: "",
    //---季警告额度
     othersWarnSeason1: "",
    othersWarnSeason2: "",
    othersWarnSeason3: "",
    othersWarnSeason4: "",

    //--季下一周期预测
    othersForecastSeason1: "",
    othersForecastSeason2: "",
    othersForecastSeason3: "",
    othersForecastSeason4: "",
    //---------------总定额月----
    //总定额
    totalMonth1: "",
    totalMonth2: "",
    totalMonth3: "",
    totalMonth4: "",
    totalMonth5: "",
    totalMonth6: "",
    totalMonth7: "",
    totalMonth8: "",
    totalMonth9: "",
    totalMonth10: "",
    totalMonth11: "",
    totalMonth12: "",

    //总消费额度
    totalConsumeMonth1: "",
    totalConsumeMonth2: "",
    totalConsumeMonth3: "",
    totalConsumeMonth4: "",
    totalConsumeMonth5: "",
    totalConsumeMonth6: "",
    totalConsumeMonth7: "",
    totalConsumeMonth8: "",
    totalConsumeMonth9: "",
    totalConsumeMonth10: "",
    totalConsumeMonth11: "",
    totalConsumeMonth12: "",
    //---总剩余额度
    totalRemainMonth1: "",
    totalRemainMonth2: "",
    totalRemainMonth3: "",
    totalRemainMonth4: "",
    totalRemainMonth5: "",
    totalRemainMonth6: "",
    totalRemainMonth7: "",
    totalRemainMonth8: "",
    totalRemainMonth9: "",
    totalRemainMonth10: "",
    totalRemainMonth11: "",
    totalRemainMonth12: "",
    //---总警告额度
    totalWarnMonth1: "",
    totalWarnMonth2: "",
    totalWarnMonth3: "",
    totalWarnMonth4: "",
    totalWarnMonth5: "",
    totalWarnMonth6: "",
    totalWarnMonth7: "",
    totalWarnMonth8: "",
    totalWarnMonth9: "",
    totalWarnMonth10: "",
    totalWarnMonth11: "",
    totalWarnMonth12: "",


    //--总下一周期预测
    totalForecastMonth1: "",
    totalForecastMonth2: "",
    totalForecastMonth3: "",
    totalForecastMonth4: "",
    totalForecastMonth5: "",
    totalForecastMonth6: "",
    totalForecastMonth7: "",
    totalForecastMonth8: "",
    totalForecastMonth9: "",
    totalForecastMonth10: "",
    totalForecastMonth11: "",
    totalForecastMonth12: "",

    //-------------电月----------------------------
    //电
    powerMonth1: "",
    powerMonth2: "",
    powerMonth3: "",
    powerMonth4: "",
    powerMonth5: "",
    powerMonth6: "",
    powerMonth7: "",
    powerMonth8: "",
    powerMonth9: "",
    powerMonth10: "",
    powerMonth11: "",
    powerMonth12: "",

    //电消费额度
    powerConsumeMonth1: "",
    powerConsumeMonth2: "",
    powerConsumeMonth3: "",
    powerConsumeMonth4: "",
    powerConsumeMonth5: "",
    powerConsumeMonth6: "",
    powerConsumeMonth7: "",
    powerConsumeMonth8: "",
    powerConsumeMonth9: "",
    powerConsumeMonth10: "",
    powerConsumeMonth11: "",
    powerConsumeMonth12: "",
    //---月剩余定额
    powerRemainMonth1: "",
    powerRemainMonth2: "",
    powerRemainMonth3: "",
    powerRemainMonth4: "",
    powerRemainMonth5: "",
    powerRemainMonth6: "",
    powerRemainMonth7: "",
    powerRemainMonth8: "",
    powerRemainMonth9: "",
    powerRemainMonth10: "",
    powerRemainMonth11: "",
    powerRemainMonth12: "",
    //---月警告定额
    powerWarnMonth1: "",
    powerWarnMonth2: "",
    powerWarnMonth3: "",
    powerWarnMonth4: "",
    powerWarnMonth5: "",
    powerWarnMonth6: "",
    powerWarnMonth7: "",
    powerWarnMonth8: "",
    powerWarnMonth9: "",
    powerWarnMonth10: "",
    powerWarnMonth11: "",
    powerWarnMonth12: "",

    //--月下一周期预测
    powerForecastMonth1: "",
    powerForecastMonth2: "",
    powerForecastMonth3: "",
    powerForecastMonth4: "",
    powerForecastMonth5: "",
    powerForecastMonth6: "",
    powerForecastMonth7: "",
    powerForecastMonth8: "",
    powerForecastMonth9: "",
    powerForecastMonth10: "",
    powerForecastMonth11: "",
    powerForecastMonth12: "",
    //--------------------
    //--------------------------水----------------------------
    waterMonth1: "",
    waterMonth2: "",
    waterMonth3: "",
    waterMonth4: "",
    waterMonth5: "",
    waterMonth6: "",
    waterMonth7: "",
    waterMonth8: "",
    waterMonth9: "",
    waterMonth10: "",
    waterMonth11: "",
    waterMonth12: "",
    //水消费额度
    waterConsumeMonth1: "",
    waterConsumeMonth2: "",
    waterConsumeMonth3: "",
    waterConsumeMonth4: "",
    waterConsumeMonth5: "",
    waterConsumeMonth6: "",
    waterConsumeMonth7: "",
    waterConsumeMonth8: "",
    waterConsumeMonth9: "",
    waterConsumeMonth10: "",
    waterConsumeMonth11: "",
    waterConsumeMonth12: "",
    //---月剩余定额
    waterRemainMonth1: "",
    waterRemainMonth2: "",
    waterRemainMonth3: "",
    waterRemainMonth4: "",
    waterRemainMonth5: "",
    waterRemainMonth6: "",
    waterRemainMonth7: "",
    waterRemainMonth8: "",
    waterRemainMonth9: "",
    waterRemainMonth10: "",
    waterRemainMonth11: "",
    waterRemainMonth12: "",
    //---月警告定额
    waterWarnMonth1: "",
    waterWarnMonth2: "",
    waterWarnMonth3: "",
    waterWarnMonth4: "",
    waterWarnMonth5: "",
    waterWarnMonth6: "",
    waterWarnMonth7: "",
    waterWarnMonth8: "",
    waterWarnMonth9: "",
    waterWarnMonth10: "",
    waterWarnMonth11: "",
    waterWarnMonth12: "",
    //--月下一周期预测
    waterForecastMonth1: "",
    waterForecastMonth2: "",
    waterForecastMonth3: "",
    waterForecastMonth4: "",
    waterForecastMonth5: "",
    waterForecastMonth6: "",
    waterForecastMonth7: "",
    waterForecastMonth8: "",
    waterForecastMonth9: "",
    waterForecastMonth10: "",
    waterForecastMonth11: "",
    waterForecastMonth12: "",
    //-------------------------气------------------------
    gasMonth1: "",
    gasMonth2: "",
    gasMonth3: "",
    gasMonth4: "",
    gasMonth5: "",
    gasMonth6: "",
    gasMonth7: "",
    gasMonth8: "",
    gasMonth9: "",
    gasMonth10: "",
    gasMonth11: "",
    gasMonth12: "",
    //气消费额度
    gasConsumeMonth1: "",
    gasConsumeMonth2: "",
    gasConsumeMonth3: "",
    gasConsumeMonth4: "",
    gasConsumeMonth5: "",
    gasConsumeMonth6: "",
    gasConsumeMonth7: "",
    gasConsumeMonth8: "",
    gasConsumeMonth9: "",
    gasConsumeMonth10: "",
    gasConsumeMonth11: "",
    gasConsumeMonth12: "",
    //---月剩余定额
    gasRemainMonth1: "",
    gasRemainMonth2: "",
    gasRemainMonth3: "",
    gasRemainMonth4: "",
    gasRemainMonth5: "",
    gasRemainMonth6: "",
    gasRemainMonth7: "",
    gasRemainMonth8: "",
    gasRemainMonth9: "",
    gasRemainMonth10: "",
    gasRemainMonth11: "",
    gasRemainMonth12: "",
    //---月警告定额
    gasWarnMonth1: "",
    gasWarnMonth2: "",
    gasWarnMonth3: "",
    gasWarnMonth4: "",
    gasWarnMonth5: "",
    gasWarnMonth6: "",
    gasWarnMonth7: "",
    gasWarnMonth8: "",
    gasWarnMonth9: "",
    gasWarnMonth10: "",
    gasWarnMonth11: "",
    gasWarnMonth12: "",
    //--月下一周期预测
    gasForecastMonth1: "",
    gasForecastMonth2: "",
    gasForecastMonth3: "",
    gasForecastMonth4: "",
    gasForecastMonth5: "",
    gasForecastMonth6: "",
    gasForecastMonth7: "",
    gasForecastMonth8: "",
    gasForecastMonth9: "",
    gasForecastMonth10: "",
    gasForecastMonth11: "",
    gasForecastMonth12: "",

    //--------------------热-------------------------------
    hotMonth1: "",
    hotMonth2: "",
    hotMonth3: "",
    hotMonth4: "",
    hotMonth5: "",
    hotMonth6: "",
    hotMonth7: "",
    hotMonth8: "",
    hotMonth9: "",
    hotMonth10: "",
    hotMonth11: "",
    hotMonth12: "",
    //热消费额度
    hotConsumeMonth1: "",
    hotConsumeMonth2: "",
    hotConsumeMonth3: "",
    hotConsumeMonth4: "",
    hotConsumeMonth5: "",
    hotConsumeMonth6: "",
    hotConsumeMonth7: "",
    hotConsumeMonth8: "",
    hotConsumeMonth9: "",
    hotConsumeMonth10: "",
    hotConsumeMonth11: "",
    hotConsumeMonth12: "",
    //---月剩余定额
    hotRemainMonth1: "",
    hotRemainMonth2: "",
    hotRemainMonth3: "",
    hotRemainMonth4: "",
    hotRemainMonth5: "",
    hotRemainMonth6: "",
    hotRemainMonth7: "",
    hotRemainMonth8: "",
    hotRemainMonth9: "",
    hotRemainMonth10: "",
    hotRemainMonth11: "",
    hotRemainMonth12: "",
    //---月警告定额
    hotWarnMonth1: "",
    hotWarnMonth2: "",
    hotWarnMonth3: "",
    hotWarnMonth4: "",
    hotWarnMonth5: "",
    hotWarnMonth6: "",
    hotWarnMonth7: "",
    hotWarnMonth8: "",
    hotWarnMonth9: "",
    hotWarnMonth10: "",
    hotWarnMonth11: "",
    hotWarnMonth12: "",

    //--月下一周期预测
    hotForecastMonth1: "",
    hotForecastMonth2: "",
    hotForecastMonth3: "",
    hotForecastMonth4: "",
    hotForecastMonth5: "",
    hotForecastMonth6: "",
    hotForecastMonth7: "",
    hotForecastMonth8: "",
    hotForecastMonth9: "",
    hotForecastMonth10: "",
    hotForecastMonth11: "",
    hotForecastMonth12: "",
    //--------------------------------------其他----

    othersMonth1: "",
    othersMonth2: "",
    othersMonth3: "",
    othersMonth4: "",
    othersMonth5: "",
    othersMonth6: "",
    othersMonth7: "",
    othersMonth8: "",
    othersMonth9: "",
    othersMonth10: "",
    othersMonth11: "",
    othersMonth12: "",

    //其他消费额度
    othersConsumeMonth1: "",
    othersConsumeMonth2: "",
    othersConsumeMonth3: "",
    othersConsumeMonth4: "",
    othersConsumeMonth5: "",
    othersConsumeMonth6: "",
    othersConsumeMonth7: "",
    othersConsumeMonth8: "",
    othersConsumeMonth9: "",
    othersConsumeMonth10: "",
    othersConsumeMonth11: "",
    othersConsumeMonth12: "",
    //---其他剩余定额
    othersRemainMonth1: "",
    othersRemainMonth2: "",
    othersRemainMonth3: "",
    othersRemainMonth4: "",
    othersRemainMonth5: "",
    othersRemainMonth6: "",
    othersRemainMonth7: "",
    othersRemainMonth8: "",
    othersRemainMonth9: "",
    othersRemainMonth10: "",
    othersRemainMonth11: "",
    othersRemainMonth12: "",

    //---其他警告定额
    othersWarnMonth1: "",
    othersWarnMonth2: "",
    othersWarnMonth3: "",
    othersWarnMonth4: "",
    othersWarnMonth5: "",
    othersWarnMonth6: "",
    othersWarnMonth7: "",
    othersWarnMonth8: "",
    othersWarnMonth9: "",
    othersWarnMonth10: "",
    othersWarnMonth11: "",
    othersWarnMonth12: "",
    //--其他下一周期预测
    othersForecastMonth1: "",
    othersForecastMonth2: "",
    othersForecastMonth3: "",
    othersForecastMonth4: "",
    othersForecastMonth5: "",
    othersForecastMonth6: "",
    othersForecastMonth7: "",
    othersForecastMonth8: "",
    othersForecastMonth9: "",
    othersForecastMonth10: "",
    othersForecastMonth11: "",
    othersForecastMonth12: "",
        },
      
    };
   
    
  },
  created() { 
    getQuotaLevel1(this.queryParams).then((response) => {
          
          this.quotaLevel1VO = response.data;
  
  
        
         });
           getGasLevel2(this.queryParams).then((response) => {
        
          this.quotaLevel2VO = response.data;
          //alert(this.quotaLevel2VO.arealist.length);
      });
     this.getProjectList(141);
  },
   methods: {
      // 设置日期范围查询条件
     setFlag1(iflag) {
        // alert("child="+iflag);
        //   this.flag=iflag;
        this.$emit("changeFlag",iflag);
       //  alert("child="+iflag);

     },
     
       //----------------位置选择----------------------------
             selectPosition(node){
                this.queryParams.positionId = node.positionId;
                //alert(this.listQuery.positionId);
               },
                
           
            getProjectList(companyId){
             // alert(companyId);
                getProjectList({"companyId":companyId}).then(res=>{
                    this.projectList = res;
                    //alert(this.projectList.length);
                })
                
            },
           changeProject() {
                // alert(this.queryParams.projectId);
                if(this.queryParams.projectId == ''){
                    this.queryParams.projectId = null;
                    this.queryParams.positionId = null;
                    this.positionList = [];
                }else{                   
                   getPositionTree({"projectId":this.queryParams.projectId}).then(response =>{
                     
                      // alert(this.queryParams.projectId);
                        this.queryParams.positionId = null;
                        this.positionList = [];
                        let data = listToTree(response,"positionId","parentId");
                        this.recursivePosition(data)
                    });
                }
            },
            //递归位置列表修改属性及数据结构
            recursivePosition(row){
                let data = row.map(v => {
                    v.label = v.positionName;
                    v.id = v.positionId;
                    if(v.children != undefined){
                        this.recursivePosition(v.children);
                    }
                    return v
                })
                //alert(this.queryParams.projectId);
                this.positionList = data;
            },
          
           

    //----------------------------------------------   
                routerurl(flag){
         switch(flag){
           case 1:
              this.$router.push('/quota/level2/power/index');
             break;
           case 2:
              this.$router.push('/quota/level2/water/index');
              break;
             
           case 3:
              this.$router.push('/quota/level2/gas/index');
             break;
           case 4:
              this.$router.push('/quota/level2/hot/index');
             break;
          case 5:
              this.$router.push('/quota/level2/others/index');
             break;   
         }
     },
          /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
       /** 查询列表 */
    getList() {
      this.loading = true;

      listGas(this.queryParams).then((response) => {
     
         for(var i=0;i<response.rows.length;i++){
        
            //if(response.rows[i].childEnergyType==1){
               //response.rows[i].energyMonth=response.rows[i].energyYear+'-'+response.rows[i].energyMonth;
               response.rows[i].energyMonth=response.rows[i].energyMonth+'月';
              // response.rows[i].childEnergyType='冷暖空调';
            //}
          
           
        }
      
        this.consumptionList = response.rows;
         // alert(this.consumptionlist.length);
        this.total = response.total;
        this.loading = false;
      });
    },
   }
}
</script>
<style scoped src="../../../../../../assets/common/quota/css/gas/styles.css"></style>
<style scoped src="../../../../../../assets/common/consumption/css/styles.css"></style>
<style scoped src="../../../../../../assets/common/rp_page.css"></style>
<style scoped>
   .app-container1 {
  margin: 10px;
  
  background-color: rgba(243, 247, 255, 1);
  border-radius: 5px;
  min-height: calc(100vh + 900px);
  
}
.pagination-container {
  background: rgba(255, 255, 255, 0.0235294117647059);
  padding: 18px 0px;
  float: left;
  z-index: 99;
position: absolute;
}
   .innerbox{
            overflow-x: hidden;
            overflow-y: auto;       
        }
        /*滚动条样式*/
   .innerbox::-webkit-scrollbar {
           	width: 8px;
            height: 8px;
            background-color: #F5F5F5;
    }
    .innerbox::-webkit-scrollbar-thumb {
            	border-radius:3px;
	box-shadow: inset 0 0 6px rgba(0,0,0,.3);
	background-color: #555;
    }
    .innerbox::-webkit-scrollbar-track {
          	box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
            border-radius: 3px;
            background-color: #F5F5F5;

    }
  .fontset{
      font-family:'PingFangSC-Regular', 'PingFang SC', sans-serif;
      font-weight:400;
      font-style:normal;
  }

</style>
